const getters = {
  token: state => state.token,
  userInfo: state => state.userInfo,
  selectCustomerForSave: state => state.selectCustomerForSave,
  selectChannelForSave: state => state.selectChannelForSave,
  permissions: state => state.permissions,
}
export default getters